import { useState } from "react";
import { CardContainer, Button, FormInput } from "../../../../components";
import { useDispatch } from "react-redux";
import { setShopInfo } from "../../../../redux/shop";
import { shopUpdate } from "../../../../lib/ec2-api-lib";

const str = {
  keyExistComment: "보안정보가 이미 존재합니다.",
  failure: "저장에 실패했습니다.",
  success: "성공적으로 저장하였습니다.",
  valComment: "'사용자에게 통보' 하기 위해서는 먼저 `스토어앱에 주문 통보` 가 선행 되어야 합니다."
}

export function ReviewSiteRegister(props) {
  const { shopInfo } = props

  // const { gStyle } = useStyles()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false);
  const [reviewSiteUrl, setReviewSiteUrl] = useState(shopInfo?.reviewSiteUrl || "");

  const submitOptions = async () => {
    try {
      setIsLoading(true)

      const body = { reviewSiteUrl }
      const res = await shopUpdate({ shopId: shopInfo.shopId, body })
      if (res.err) throw Error(res.err.message)

      const newShopInfo = {
        ...shopInfo,
        reviewSiteUrl
      }
      dispatch(setShopInfo({ shopInfo: newShopInfo }));
      alert(str.success)
    } catch (e) {
      alert(str.failure + " - " + e.message)
    } finally {
      setIsLoading(false)
      props.history.push('/')
    }
  }

  return (
    <CardContainer
      title="리뷰 사이트 등록"
      onClickBack={() => props.history.push('/')}
      variant="md"
    >
      <FormInput
        label="리뷰 사이트 URL"
        name="reviewSiteUrl"
        value={reviewSiteUrl}
        onChange={(e) => setReviewSiteUrl(e.target.value.trim())}
      />

      <br />
      <Button
        size="sm"
        width="100%"
        variant="primary"
        title="확인"
        isLoading={isLoading}
        onClick={submitOptions}
      />

    </CardContainer>
  );
}
